import i18n from 'i18next'

export const MIN_ZOOM_TO_SELECT = 15
export const ZOOM_INCREMENT = 2
export const LOCATION_ZOOM = 17

export interface MapDefaults {
  latitude: number
  longitude: number
  zoom: number
}

const fallbackMapDefaults: MapDefaults = {
  latitude: 48.17691,
  longitude: 11.56013,
  zoom: 6,
}

export function getMapDefaults(): MapDefaults {
  const result = i18n.t('map.defaultCenter', { returnObjects: true }) as MapDefaults

  if (
    typeof result?.latitude === 'number' &&
    typeof result?.longitude === 'number' &&
    typeof result?.zoom === 'number'
  ) {
    return result
  }
  return fallbackMapDefaults
}
